import React, { useState, useEffect, useRef } from 'react';
import './Customers.css';

const clients = [
  // {
  //   file: 'Sailesh_Patel.jpeg',
  //   name: 'Sailesh Patel',
  //   review: 'The Moringa powder from AdiYogi is absolutely pure. I can feel the difference in my health since I started using it.',
  // },
  // {
  //   file: 'Veer_Patel.jpeg',
  //   name: 'Veer Patel',
  //   review: 'Amazing quality products. Knowing they come directly from a natural farm gives me complete peace of mind.',
  // },
  // {
  //   file: 'Sandeep_Rajak.jpeg',
  //   name: 'Sandeep Rajak',
  //   review: 'Amazing quality products. Knowing they come directly from a natural farm gives me complete peace of mind.',
  // },
  {
    file: 'Ravi_Mishra.jpeg',
    name: 'Ravi Mishra',
    review: 'Amazing quality products. Knowing they come directly from a natural farm gives me complete peace of mind.',
  },
  {
    file: 'Pratima_Mishra.jpeg',
    name: 'Pratima Mishra',
    review: 'The freshness and quality are outstanding. Knowing its grown naturally on the farm makes every purchase feel worthwhile.',
  },
];

const INITIAL_SHOW = 3;

export default function Customers() {
  const [showAll, setShowAll] = useState(false);
  const sectionRef = useRef(null);
  const visible = showAll ? clients : clients.slice(0, INITIAL_SHOW);

  // Re-run reveal observer whenever visible list changes
  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const targets = section.querySelectorAll('.reveal:not(.visible)');
    if (targets.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, i) => {
          if (entry.isIntersecting) {
            setTimeout(() => entry.target.classList.add('visible'), i * 100);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    targets.forEach((t) => observer.observe(t));
    return () => observer.disconnect();
  }, [visible.length]);

  return (
    <section className="customers-section" id="customers" ref={sectionRef}>
      <div className="section-header reveal">
        <h2>Customer Experiences</h2>
        <p>Real people, real results — straight from our happy customers.</p>
      </div>
      <div className="customers-grid">
        {visible.map(({ file, name, review }, i) => (
          <div
            className="customer-card reveal visible"
            key={name}
            style={{ transitionDelay: `${i * 0.13}s` }}
          >
            <div className="customer-img-wrap">
              <img
                src={`/clients/${file}`}
                alt={name}
                onError={(e) => { e.target.style.display = 'none'; }}
              />
            </div>
            <div className="customer-info">
              <p className="customer-review">"{review}"</p>
              <p className="customer-name">— {name}</p>
              <div className="stars" aria-label="5 stars">★★★★★</div>
            </div>
          </div>
        ))}
      </div>

      {!showAll && clients.length > INITIAL_SHOW && (
        <div className="show-all-wrap">
          <button className="show-all-btn" onClick={() => setShowAll(true)}>
            Show All {clients.length} Customers
          </button>
        </div>
      )}
      {showAll && (
        <div className="show-all-wrap">
          <button className="show-all-btn outline" onClick={() => setShowAll(false)}>
            Show Less
          </button>
        </div>
      )}
    </section>
  );
}
